<template>
  <div class="record-info">
    <div class="record-info-main clearfix">
      <span class="info-main-item">
        <span class="label">主诉：</span>
        <!-- 用于解决列表和保存的字段引起的不一致问题 -->
        <span>{{
          recordItem.chiefComplaint || recordItem.purposeOfConsultationName
        }}</span>
      </span>
      <span class="info-main-item">
        <span class="label">诊断：</span>
        <!-- 用于解决列表和保存的字段引起的不一致问题 -->
        <span>{{ recordItem.diseaseName || recordItem.diseaseTypeName }}</span>
      </span>
      <span class="info-main-item">
        <span class="label">医生：</span>
        <span>{{ recordItem.doctorName ? recordItem.doctorName : "--" }}</span>
      </span>
      <span class="info-main-item">{{
        recordItem.hospitalName ? recordItem.hospitalName : ""
      }}</span>
      <!-- 用于解决列表和保存的字段引起的不一致问题 -->
      <span class="info-main-item">{{
        recordItem.visitDateTime || recordItem.visitDate
      }}</span>
    </div>
    <div class="record-info-item">
      <div class="label">症状：</div>
      <div class="content clearfix">
        <span
          class="symptom-item"
          v-for="(ds_item, index) in recordItem.dsNamesList"
          :key="index"
        >
          {{ ds_item.label }}
          <i v-if="ds_item.add" class="symptom-icon add-icon">增</i>
        </span>
        <span
          class="symptom-item"
          v-for="(ds_item, index) in recordItem.dsNamesReduce"
          :key="index + 'Reduce'"
        >
          {{ ds_item }}
          <i class="symptom-icon">减</i>
        </span>
      </div>
    </div>
    <div class="record-info-item">
      <div class="label">医生开方：</div>
      <!-- 用于解决列表和保存的字段引起的不一致问题 -->
      <div
        class="quantity"
        v-if="
          recordItem.doctorPrescription &&
          JSON.parse(recordItem.doctorPrescription).length !== 0
        "
      >
        x<span class="num">{{
          JSON.parse(recordItem.doctorPrescription)[0].quantity
        }}</span>
      </div>
      <div
        class="quantity"
        v-if="
          recordItem.hisDrugsVOList && recordItem.hisDrugsVOList.length !== 0
        "
      >
        x<span class="num">{{ recordItem.hisDrugsVOList[0].quantity }}</span>
      </div>
      <div class="content" v-if="recordItem.doctorPrescription">
        <div
          v-if="
            recordItem.doctorPrescription &&
            JSON.parse(recordItem.doctorPrescription).length === 0
          "
        >
          --
        </div>
        <drugsFormat
          v-else
          :size="6"
          :list="JSON.parse(recordItem.doctorPrescription)"
        />
      </div>
      <div class="content" v-if="recordItem.hisDrugsVOList">
        <div
          v-if="
            recordItem.hisDrugsVOList && recordItem.hisDrugsVOList.length === 0
          "
        >
          --
        </div>
        <drugsFormat v-else :size="6" :list="recordItem.hisDrugsVOList" />
      </div>
    </div>
    <div class="record-info-item">
      <div class="label">系统开方：</div>
      <div
        class="quantity"
        v-if="
          recordItem.systemPrescription &&
          JSON.parse(recordItem.systemPrescription).length !== 0
        "
      >
        x<span class="num">{{
          JSON.parse(recordItem.systemPrescription)[0].quantity
        }}</span>
      </div>
      <div
        class="quantity"
        v-if="
          recordItem.sanfangDiagnosticDrugsVOList &&
          recordItem.sanfangDiagnosticDrugsVOList.length !== 0
        "
      >
        x<span class="num">{{
          recordItem.sanfangDiagnosticDrugsVOList[0].quantity
        }}</span>
      </div>
      <!-- 用于解决列表和保存的字段引起的不一致问题 -->
      <div class="content" v-if="recordItem.systemPrescription">
        <div
          v-if="
            recordItem.systemPrescription &&
            JSON.parse(recordItem.systemPrescription).length === 0
          "
        >
          --
        </div>
        <drugsFormat
          v-else
          :size="6"
          :list="JSON.parse(recordItem.systemPrescription)"
        />
      </div>
      <div
        class="content"
        v-if="
          recordItem.sanfangDiagnosticDrugsVOList ||
          recordItem.diagnosticDrugsVOList
        "
      >
        <div
          v-if="
            recordItem.sanfangDiagnosticDrugsVOList &&
            recordItem.sanfangDiagnosticDrugsVOList.length
          "
        >
          <drugsFormat
            :size="6"
            :list="recordItem.sanfangDiagnosticDrugsVOList"
          />
        </div>
        <div v-else>
          <drugsFormat :size="6" :list="recordItem.diagnosticDrugsVOList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recordItem: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped lang="scss">
.clearfix {
  &:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}

.record-info {
  color: #606266;
  line-height: 28px;

  .label {
    color: #000;
  }

  .record-info-main {
    .info-main-item {
      float: left;
      margin-right: 32px;
    }
  }

  .record-info-item {
    position: relative;
    .quantity {
      position: absolute;
      right: 0;
      top: 0;
      color: #ff0000;
      font-size: 20px;
      .num {
        font-size: 26px;
        padding-left: 4px;
      }
    }
    .content {
      color: #333;

      .mg-small {
        margin-right: 16px;
      }

      .symptom-item {
        float: left;
        border: 1px solid #ccc;
        padding: 0 8px;
        position: relative;
        margin: 0 15px 10px 0;
        white-space: nowrap;
        border-radius: 4px;

        .symptom-icon {
          position: absolute;
          top: -8px;
          right: -10px;
          background-color: #333333;
          color: #ffffff;
          border-radius: 10px;
          line-height: 18px;
          font-size: 12px;
          font-style: normal;
          padding: 0 4px;
          z-index: 1;

          &.add-icon {
            background-color: #ff0000;
          }
        }
      }
    }
  }
}
</style>